/**
 * Created by Victor Rojo on 1/9/17.
 */
import { NgModule, ModuleWithProviders,
         Optional, SkipSelf}              from '@angular/core';
import { CommonModule }                   from '@angular/common';
import { FormsModule,
         ReactiveFormsModule }            from '@angular/forms';
import { HttpClientModule,
         HTTP_INTERCEPTORS }              from '@angular/common/http';
import { FlexLayoutModule }               from '@angular/flex-layout';
import { SimpleNotificationsModule }      from "angular2-notifications";
import { RecaptchaModule }                from 'ng-recaptcha';
import { RecaptchaFormsModule }           from 'ng-recaptcha';

import {AuthRoutingModule}                from './auth-routing.module';

import { LoginComponent }                 from './login/login.component';
import { AuthService, AuthServiceConfig } from './auth.service';
import { AuthGuard }                      from './auth-guard.service';
import { Credential }                     from './credential';
import { SignupComponent }                from './signup/signup.component';
import { PasswordStrengthComponent }      from './password-strength/password-strength.component';
import { ErrorInterceptor }               from "./error-interceptor";
import { ActivateComponent }              from "./activate/activate.component";
import { PasswordRecoveryComponent }      from "./password-recovery/password-recovery.component";
import { PasswordResetComponent }         from "./password-recovery/password-reset.component";
import {PreviousRouteService} from "./PreviousRoute.service";
import {TryDemoComponent} from "./try-demo/try-demo.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FlexLayoutModule,
    SimpleNotificationsModule.forRoot(),
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
    AuthRoutingModule
  ],
  exports: [
    PasswordStrengthComponent
  ],
  declarations: [
    LoginComponent,
    SignupComponent,
    ActivateComponent,
    PasswordStrengthComponent,
    PasswordRecoveryComponent,
    PasswordResetComponent,
    TryDemoComponent
  ],
  providers: [
    AuthService,
    PreviousRouteService,
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    }
  ]
})
export class AuthModule {

  constructor (@Optional() @SkipSelf() parentModule: AuthModule) {
    if (parentModule) {
      throw new Error(
        'AuthModule is already loaded. Import it in the AppModule only');
    }
  }

  static forRoot(config: AuthServiceConfig): ModuleWithProviders {
    return {
      ngModule: AuthModule,
      providers: [
        {provide: AuthServiceConfig, useValue: config }
      ]
    };
  }
}
